// src/lib/langChoice.js
// Remembers that the visitor has explicitly picked a language (first-visit prompt).
// Stored in localStorage AND in a first-party cookie (1 year), like a normal preference cookie.
const FLAG_KEY = "site_lang_chosen";
const COOKIE_LANG = "site_lang";
const MAX_AGE = 60 * 60 * 24 * 365;

function readCookie(name) {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : null;
  } catch {
    return null;
  }
}

function writeCookie(name, value) {
  try {
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${MAX_AGE}; Path=/; SameSite=Lax${secure}`;
  } catch { /* ignore */ }
}

export function hasChosenLang() {
  try {
    if (localStorage.getItem(FLAG_KEY) === "1") return true;
  } catch { /* ignore */ }
  return readCookie(FLAG_KEY) === "1";
}

export function markLangChosen(lang) {
  try {
    localStorage.setItem(FLAG_KEY, "1");
    localStorage.setItem("site_lang", lang);
  } catch { /* ignore */ }
  writeCookie(FLAG_KEY, "1");
  writeCookie(COOKIE_LANG, lang);
  window.dispatchEvent(new Event("lang-chosen"));
}

export function onLangChosen(cb) {
  window.addEventListener("lang-chosen", cb);
  window.addEventListener("storage", cb);
  return () => {
    window.removeEventListener("lang-chosen", cb);
    window.removeEventListener("storage", cb);
  };
}
